module.exports = __webpack_public_path__ + "img/40433826.245bc35a.png";